import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Field from "../../../common/components/Field";
import { initialValues } from "./values";
import { loginFormValidationSchema } from "./validation";
import { Formik } from "formik";
import { Grid, Button, CircularProgress } from "@material-ui/core";

import styles from "./styles";

const ForgotPassword = ({
  classes,
  onRequestSend,
  isLoading,
}) => {
  return (
    <Formik
      initialValues={initialValues()}
      validationSchema={loginFormValidationSchema}
    >
      {(formik) => (
        <Grid>
          <Field
            className={classes.textField}
            type="email"
            label="Digite seu email"
            name="email"
            formik={formik}
          />
          <Button
            onClick={() => onRequestSend(formik.values)}
            className={classes.button}
          >
             {isLoading ? (
                <CircularProgress
                  className={classes.progress}
                  size={25}
                />
              ) : (
                "REENVIAR CADASTRO DE SENHA"
              )}
          </Button>
        </Grid>
      )}
    </Formik>
  );
};

export default withStyles(styles)(ForgotPassword);
